var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 21.281 14.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c4067ea13a0109e58cd0c2fc71e6b022",
    transform: "translate(21.281) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M7.094,0a1.073,1.073,0,0,0-.828.355L.355,6.266a1.143,1.143,0,0,0,0,1.655,1.143,1.143,0,0,0,1.655,0L7.921,2.01a1.143,1.143,0,0,0,0-1.655A1.073,1.073,0,0,0,7.094,0Z",
    transform: "translate(5.911 13.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M1.182,0A1.073,1.073,0,0,0,.355.355a1.143,1.143,0,0,0,0,1.655L6.266,7.921A1.17,1.17,0,1,0,7.921,6.266L2.01.355A1.073,1.073,0,0,0,1.182,0Z",
    transform: "translate(0 13.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M1.182,0A1.117,1.117,0,0,0,0,1.182V20.1a1.117,1.117,0,0,0,1.182,1.182A1.117,1.117,0,0,0,2.365,20.1V1.182A1.117,1.117,0,0,0,1.182,0Z",
    transform: "translate(5.911 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.f61372415aa8b223d9d079a7f1b30341.svg";
export { ForwardRef as ReactComponent };